import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../boot";

export const getProductList = createAsyncThunk(
  "utils/product-list",
  async (payload) => {
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/utils/api/v1/product-list`,
        { payload }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
);
